import { DATE_FORMATS } from '@constants/date.ts';
import { formatDateBasedOnPreferences } from '@utils/date.ts';

export const formatLearningDate = (utcDate: string | null | undefined, dateFormat?: string): string | null => {
    if (!utcDate) return null;

    return formatDateBasedOnPreferences(utcDate, dateFormat ?? DATE_FORMATS.ISO);
};
